enum ProductCategory {
  REPORT = "report",
  COACHING = "coaching",
  RESUME = "resume",
  RESUME_BUILDER = "resume_builder",
  OTHER = "other"
}

export const ProductCategoryValues: ProductCategory[] = [
  ProductCategory.REPORT,
  ProductCategory.COACHING,
  ProductCategory.RESUME,
  ProductCategory.RESUME_BUILDER,
  ProductCategory.OTHER
]

export default ProductCategory
